import { c as _c } from "react/compiler-runtime";
import type { GraphOperationAddNode, GraphOperationPasteNode } from '@onefootprint/request-types/dashboard';
import groupBy from 'lodash/groupBy';
import { useTranslation } from 'react-i18next';
import useSession from '@/hooks/use-session';
import useGetNewNodeContext, { type NewNodeGroup, newNodeGroupValues } from './use-get-new-node-context';
type Operation = GraphOperationAddNode | GraphOperationPasteNode;
const useAvailableTabs = t0 => {
  const $0 = _c(17);
  const {
    operations,
    activeTab
  } = t0;
  let t1;
  if ($0[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "addNode"
    };
    $0[0] = t1;
  } else {
    t1 = $0[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t1);
  const {
    getNodeContext,
    isValidNodeKind
  } = useGetNewNodeContext();
  const {
    data: t2
  } = useSession();
  const {
    user
  } = t2;
  let groupedOperations;
  let t3;
  if ($0[1] !== getNodeContext || $0[2] !== isValidNodeKind || $0[3] !== operations || $0[4] !== t || $0[5] !== user?.isFirmEmployee) {
    let t4;
    if ($0[8] !== isValidNodeKind || $0[9] !== user?.isFirmEmployee) {
      t4 = op => {
        if (op.kind !== "add_node") {
          return false;
        }
        if (!isValidNodeKind(op.nodeKind) && !user?.isFirmEmployee) {
          return false;
        }
        return true;
      };
      $0[8] = isValidNodeKind;
      $0[9] = user?.isFirmEmployee;
      $0[10] = t4;
    } else {
      t4 = $0[10];
    }
    const addOperations = operations.filter(t4);
    let t5;
    if ($0[11] !== getNodeContext) {
      t5 = op_0 => getNodeContext(op_0.nodeKind).group;
      $0[11] = getNodeContext;
      $0[12] = t5;
    } else {
      t5 = $0[12];
    }
    groupedOperations = groupBy(addOperations, t5);
    const allTabs = Object.values(newNodeGroupValues).map(tab => ({
      label: t($ => $.groups[tab]),
      value: tab
    }));
    t3 = allTabs.filter(tab_0 => groupedOperations[tab_0.value] && groupedOperations[tab_0.value].length > 0);
    $0[1] = getNodeContext;
    $0[2] = isValidNodeKind;
    $0[3] = operations;
    $0[4] = t;
    $0[5] = user?.isFirmEmployee;
    $0[6] = groupedOperations;
    $0[7] = t3;
  } else {
    groupedOperations = $0[6];
    t3 = $0[7];
  }
  const availableTabs = t3;
  const currentActiveTab = availableTabs.some(tab_1 => tab_1.value === activeTab) ? activeTab : availableTabs[0]?.value || "data";
  let t4;
  if ($0[13] !== availableTabs || $0[14] !== currentActiveTab || $0[15] !== groupedOperations) {
    t4 = {
      availableTabs,
      currentActiveTab,
      groupedOperations
    };
    $0[13] = availableTabs;
    $0[14] = currentActiveTab;
    $0[15] = groupedOperations;
    $0[16] = t4;
  } else {
    t4 = $0[16];
  }
  return t4;
};
export default useAvailableTabs;